import _ from "lodash";
import {httpClient} from "@/Repositories/DataGathering/HttpClient";
import {GetIdFromObject} from "@/Repositories/helpers";

export default {
    async store(dataGathering, dataRecord) {
        const url = route('data-records.store', {
            id: GetIdFromObject(dataGathering),
        });

        return httpClient.post(url, dataRecord);
    },


    async search(bible, searchArguments) {
        const pagination = _.get(searchArguments, 'pagination', {}),
            order = _.get(searchArguments, 'order', []),
            conditions = _.get(searchArguments, 'conditions', {});

        searchArguments = Object.assign(
            {id: GetIdFromObject(bible)},
            pagination,
            order.length > 0? {order: order} : {}, //wrap the order array in the order key
            conditions
        );

        const url = route('data-records.search', searchArguments);

        return httpClient.get(url);
    },

    async update(dataGathering, dataRecord) {
        const url = route('data-records.update', {
            id: GetIdFromObject(dataGathering),
            record: GetIdFromObject(dataRecord),
        });

        return httpClient.put(url, dataRecord);
    },

    async delete(dataGathering, dataRecord) {
        const url = route('data-records.update', {
            id: GetIdFromObject(dataGathering),
            record: GetIdFromObject(dataRecord),
        });

        return httpClient.delete(url);
    },

    /**
     * Request to endpoint data-records.download
     * for download status in data-gathering microservice
     *
     * @param dataGathering
     *
     * @returns {Promise<*>}
     */
    async statusDownload(dataGathering) {
        const url = route('data-records.status-download',{
            id: GetIdFromObject(dataGathering),
        });

        return httpClient.get(url);
    },

    /**
     * Request to endpoint data-records.generate
     * for generate data-gathering Excel
     *
     * @param dataGathering
     *
     * @returns {Promise<*>}
     */
    async generate(dataGathering){
        const url = route('data-records.generate', {
            id: GetIdFromObject(dataGathering),
        });

        return httpClient.get(url);
    },

    /**
     * Request to endpoint data-records.download
     * for download data-gathering Excel
     *
     * @param request
     *
     * @returns {Promise<*>}
     */
    async download(request) {
        const url = route('data-records.download');

        return httpClient.post(url,{ request }, {
            responseType: 'blob',
        });
    },
}
